module.exports = __webpack_public_path__ + "img/mk-语文@2x.21e0c939.png";